import { BuyBackMakeUpEffects } from './buyback-makeup.effect';

export const PurchaseServiceEffect = [
  BuyBackMakeUpEffects,
];

export * from './buyback-makeup.effect';
